import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
  import { useRouter } from "vue-router";
  import { PlansButtonFormEnum } from "@/enums/PlansFormEnum";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CardSubscription',
  props: {
    icon: {},
    title: {},
    price: {},
    subtitle: {},
    buttonText: {},
    subtitleFeatures: {},
    features: {},
    type: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

  const hover = ref(false);

  const router = useRouter();

  const onRedirectForm = () => {
    if (props.buttonText === PlansButtonFormEnum.JOIN_WAITLIST) {
      router.push({ name: "WaitlistForm" });
    } else {
      router.push({ name: "SignUpForm" });
    }
  };

const __returned__ = { props, hover, router, onRedirectForm, ref, get useRouter() { return useRouter }, get PlansButtonFormEnum() { return PlansButtonFormEnum } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})